import { CRUDService } from './crud.service';
// import { PipeTransform } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { CRUDColumn } from './crud-dom/crud-column';
// import { DynamicPipeInstantiator } from '@alfercom/common-pipes';
import { NzDrawerRef, NzDrawerService } from 'ng-zorro-antd/drawer';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { CRUDFormFilter, CRUDPayloadData } from './types/crud.types';
import { ListaFiltriCompilabiliComponent } from './filtri/lista-filtri-compilabili/lista-filtri-compilabili.component';
import { ElencoFiltriService } from './filtri/ElencoFiltri.service';
import { ConfigFiltro } from './filtri/filtri.type';
import { TranslateService } from '@ngx-translate/core'

export abstract class CRUDServerSide<RowStructure extends { id?: any }, ResolverResponse> {

  protected resolverClass: any;

  /**
   * Element that rappresent the datasource API
   */
  protected dataService: any;

  filterSearch = null;
  expandableRow = null;

  formats: { id: string; text: string }[] = [
    { id: "xlsx", text: "XLSX" },
    { id: "csv", text: "CSV" },
    { id: "pdf", text: "PDF" },
  ];

  nomeFiltroRicerca = '';

  formFilter: CRUDFormFilter = { filterSearch: '' };
  filterValue: string = '';

  private showInsertFiltriDrawer: boolean = false;
  private elencoFiltriDrawerRef: NzDrawerRef;

  nFiltriAttivi: number = 0;

  defautHeight: number = 30;
  showTable: boolean = true;
  rows: RowStructure[] = [];
  exportColumns: CRUDColumn[] = [];
  allColumns: CRUDColumn[] = [];
  columns: CRUDColumn[] = [];
  showSelezioneColonneEW: boolean = false;//Selezione delle colonne dentro all'export wizard
  hideCheckboxColumn: boolean = false;//colonna checkbox della tabella

  currentQuery: any = {};

  limit: number = 20;
  orderBy: any;
  offset: number;
  total: number;
  selectionType: string = 'single';

  selected: any[] = [];

  isLoading: boolean = false;

  hasFiltersSettings: boolean = false;
  currentQueryParams: any;
  defaultNMaxColumnPDF: number = 11;

  /**
   * Attiva caricamento datatable
   */
  loading: boolean = false;

  /**
   * Keeps the original rows coming from the server
   */
  originData: any[] = [];

  //Parametri passati per il resolver (componenti usati come 'figli')
  crudResolverParameters: any;

  expandableRowPropBL: string[] = [];

  //nuova gestione export PA
  exportModal: NzModalRef = null;

  payloadResolver: CRUDPayloadData = null

  lastQueryParsed: any = null;

  protected crudService: CRUDService;
  protected activatedRoute: ActivatedRoute = null;
  protected useFiltri: boolean = false; //  protected sessionStorage:SessionStorageService=null,
  protected modalService: NzModalService = null;
  protected drawerService: NzDrawerService
  protected translateService: TranslateService

  constructor(
    inputs: {
      crudService: CRUDService,
      modalService?: NzModalService,
      drawerService?: NzDrawerService,
      translateService?: TranslateService,
    }
  ) {
    const { crudService, modalService, drawerService, translateService } = inputs;
    this.crudService = crudService;
    this.modalService = modalService ? modalService : null;
    this.drawerService = drawerService ? drawerService : null;
    this.translateService = translateService ? translateService : null;
    this.subscribeToCRUDObservables();


    // if (elencoFiltriService) {
    //   elencoFiltriService.getListaFiltriAsObservable().pipe(bufferTime(500), filter(el => el.length > 0), map(el => {
    //     return el[el.length - 1]
    //   })).subscribe(
    //     filtri => {
    //       this.onFiltriAggiornati(filtri)
    //       const filtriAttivi = filtri.filter(el => {
    //         return el.isAttivo;
    //       });
    //       this.onFiltriAttiviAggiornati(filtriAttivi)
    //     });
    //   elencoFiltriService.setFiltri(this.datiFiltri);//InitFiltri già presenti
    // }

  }

  protected retrievePayloadData() {
    return null;
  }

  protected abstract retrieveResolverClass();

  protected abstract retrieveResolverParams();

  protected retrieveColumns(extra?: { isExport?: boolean; }) {
    return [];
  }

  protected init() {
    this.columns = this.retrieveColumns();
    //init searchFilter
    this.crudService.getSearchValue().subscribe(searchValue => this.formFilter.filterSearch = searchValue);
    this.crudService.init(this.retrieveResolverClass(), this.retrieveResolverParams(), this.retrievePayloadData(), this.retrieveColumns(), this.retrieveColumns({ isExport: true }));

  }

  protected handleCurrentQueryParams(queryParams) { }

  getIsMapRowsForSingleElement() {
    return true;
  }

  /**
   * Override per modificare comporamento
   * @param row oppure intero array
   */
  mapRows(row: RowStructure | RowStructure[], index = null) {
    return row;
  }

  /**
   * Evento per selezioanre righe
   * @param array di elementi selezionati
   */
  onSelect({ selected }) {
    //sente se avviene la selezione
    this.selected.splice(0, this.selected.length);
    this.selected.push(...selected);
  }

  checkSelectable(row: any) {
    if (this.selectionType == "single") {
      const found = this.selected.find(x => "" + x.id == "" + row.id);
      return !!found;
    }
    return true;
  }

  changePage(offset: number) {
    this.crudService.changeOffset(offset);
  }

  onSort(event: {
    column: {
      name: string;
      prop: string;
    };
    newValue: string;
    prevValue: string;
  }) {
    this.crudService.order({ prop: event.column.prop, dir: event.newValue });
  }

  getRowIdentity(row: any) {
    return row.id;
  }


  showTableNow() {
    this.showTable = true;
  }

  hideTableNow() {
    this.showTable = false;
  }



  onCerca(value?: string) {
    this.filterValue = value !== undefined ? value : this.formFilter.filterSearch;
    this.crudService.setSearchValue(this.filterValue);
    this.crudService.triggerSearch();
  }


  /**
   * Ritorna tutti recordi in base la filtro impostato
   */
  getAllRecords() {
    return this.crudService.runQuery({ getAll: true, returnData: true });
  }

  propNotIs(prop, values: string[]) {
    return undefined === values.find(x => x === prop);
  }

  getFunctionId() {
    return 'CRUD';
  }

  // //pipe function
  // pipeValue(pipeName, value) {
  //   const pipe: PipeTransform = pipeName ? DynamicPipeInstantiator.getPipe(pipeName, ['it']) : null;
  //   if (pipe) {
  //     try {
  //       return pipe.transform(value);
  //     } catch (e) {
  //       return '-';
  //     }
  //   }
  //   return value;
  // }

  /**
   * Set values
   * @param data
   */
  protected setValues(data: RowStructure[]) {
    let tempSelected = [...this.selected]; //copio vecchia selezione (non copio il riferimento)
    this.rows = data; //aggiorno dataset
    this.originData = [...this.rows];
    this.addExistingSelectedRows(tempSelected); //ri-seleziono le righe mancanti
  }

  /**
   * Riseleziona le righe precedentemente selezionate una volta aggiornato il dataset della tabella
   * @param previousSelected selezione esistente prima dell'aggiornamento dei dati
   */
  addExistingSelectedRows(previousSelected: any[]) {
    this.selected = [];
    const selected = this.rows.filter(row => previousSelected.find(prevSelect => "" + prevSelect.id == "" + row.id));
    this.selected.push(...selected);
  }

  /**
   * Servizio per gestire API di un modello
   * @param dataService
   */
  setDataService(dataService: any) {
    this.dataService = dataService;
  }

  mapRowsExport(el) {
    return this.mapRows(el);
  }

  getResolverClass() {
    return this.crudService.serverSideDriver || null;
  }

  getColumns(): CRUDColumn[] {
    return this.columns || []
  }

  setColumns(columns: CRUDColumn[]) {
    this.columns = [...columns]
  }

  getColumnsExport(): CRUDColumn[] {
    return this.exportColumns || []
  }

  setColumnsExport(columns: CRUDColumn[]) {
    this.exportColumns = [...columns]
  }

  protected getFiltriTitle(): string {
    return this.translateService ? this.translateService.instant('FEPB_CRUD_FILTERDRAWERTITLE') : "Applica filtri";
  }

  protected getFiltriDrawerWidth(): number {
    return 350;
  }

  private getFiltriDrawerOffset() {
    return this.showInsertFiltriDrawer ? 180 : 0;
  }


  toggleInsertFiltriDrawer() {
    //todo
    return () => {
      this.showInsertFiltriDrawer = !this.showInsertFiltriDrawer;
      this.elencoFiltriDrawerRef.nzOffsetX = this.getFiltriDrawerOffset()
    }
  }

  apriFiltri() {
    if (!this.useFiltri) {
      throw new Error("useFiltri a FALSE!")
    }
    if (!this.crudService.getFiltersService()) {
      throw new Error("Elenco filtri service non passato al CRUD!")
    }
    if (!this.drawerService) {
      throw new Error("Drawer service non passato al CRUD!")
    }
    const values = {
      nzTitle: this.getFiltriTitle(),
      nzContent: ListaFiltriCompilabiliComponent,
      nzWidth: this.getFiltriDrawerWidth(),
      nzContentParams: {
        elencoFiltriService: this.crudService.getFiltersService(),
        drawerService: this.drawerService,
        configFiltri: this.crudService.getFiltersSettings(),
        datiFiltri: this.crudService.getFilters(),
        toggleInsertFiltriDrawer: this.toggleInsertFiltriDrawer()
      },
      nzOffsetX: this.getFiltriDrawerOffset()
    }
    this.elencoFiltriDrawerRef = this.drawerService.create<ListaFiltriCompilabiliComponent,
      {
        elencoFiltriService: ElencoFiltriService,
        datiFiltri: any[],
        configFiltri: ConfigFiltro[],
        drawerService: NzDrawerService,
        toggleInsertFiltriDrawer: () => void;
      }, string>(values);

    this.elencoFiltriDrawerRef.afterClose.subscribe(data => {
      this.showInsertFiltriDrawer = false;
    });
  }

  onRefreshCrud(refresh: boolean) {
    if (refresh) {
      this.crudService.runQuery({ forceRunQuery: true });
    }
  }

  private subscribeToCRUDObservables() {
    this.crudService.getPagination().subscribe(pagingConfig => {
      this.limit = pagingConfig.limit;
      this.orderBy = pagingConfig.orderBy ? [pagingConfig.orderBy] : [];
      this.offset = pagingConfig.offset;
      this.total = pagingConfig.total;
      this.selectionType = pagingConfig.selectionType;
    });

    this.crudService.getCurrentQuery().subscribe(query => {
      this.currentQuery = query;
    });

    this.crudService.getRows().subscribe(rows => {
      this.rows = [];
      this.rows = [...rows.map(this.mapRows, this)] as any[];
      if (this.selected.length > 0) {
        this.addExistingSelectedRows([...this.selected]);
      }
    });

    this.crudService.getIsLoading().subscribe(res => {
      this.isLoading = res;
    });
  }

  export(type: string, fileName: string, columns: any[] = null) {
    return this.crudService.export(type, fileName, columns);
  }
}
